import { VerificationView } from "@pjs/feedback";
import { react2angular } from "@pebblepad/react2angular";
import { angularAMD } from "@pebblepad/amd";
angularAMD.component("verificationView", react2angular(VerificationView));
